import { Paper, Tabs, Tab, Tooltip } from "@mui/material";
import useAuth from "$hooks/useAuth";
import AdminTab from "./tabs/AdminTab";
import ShippingTab from "./tabs/ShippingTab";
import { theme } from "$utils/theme/bataillog";
import ProfileEDBModals from "./components/Modals";
import TitleHeader from "./components/TitleHeader";
import { Layout, TabPanel } from "$components";
import InformationsTab from "./tabs/InformationsTab";
import MaterialNeedTab from "./tabs/MaterialNeedTab";
import { useStyles } from "./styles/ProfileEDB.styles";
import useProfileEDBTable from "./hooks/useProfileEDBTable";
import { useProfileEDBContext } from "./context/ProfileEDBContext";
import { EdbStatus } from "$types/EDB";

function EDBProfileContent() {
  const classes = useStyles();
  const { isAdmin } = useAuth();
  const { renderHead } = useProfileEDBTable();
  const { edb, currentTab, handleChangeTab } = useProfileEDBContext();

  const isWaiting = edb?.status === EdbStatus.WAITING;

  return (
    <Layout
      renderHead={renderHead}
      title={edb?.edbId || "Fiche EDB"}
      titleCustom={<TitleHeader />}
    >
      <Paper className={classes.stepContainer}>
        <Tabs
          className={classes.tabheader}
          value={currentTab}
          onChange={handleChangeTab}
          aria-label="EDB tabs"
          sx={{
            "& .MuiTabs-indicator": {
              backgroundColor: `${theme.color.blueLight} !important`,
              height: `3px !important`,
            },
            "& .MuiTab-root": {
              textTransform: `none !important`,
              fontSize: `18px !important`,
              padding: `12px 24px !important`,
            },
            "& .MuiTab-root.Mui-selected": {
              color: `${theme.color.blueLight} !important`,
            },
            "& .MuiTab-root.Mui-disabled": {
              color: `rgba(0, 0, 0, 0.3) !important`,
              opacity: `0.5 !important`,
            },
          }}
        >
          <Tab label="Informations" />
          <Tab label="Besoin matériel" />
          <Tab label="Préparation et livraison" />
          {isAdmin() && (
            <Tab
              label={
                isWaiting ? (
                  <Tooltip title="En attente d'approbation" placement="top">
                    <span>Traitement de l&apos;EDB</span>
                  </Tooltip>
                ) : (
                  "Traitement de l'EDB"
                )
              }
              disabled={isWaiting}
            />
          )}
        </Tabs>
        <div className={currentTab === 1 ? classes.tabContents : null}>
          <TabPanel value={currentTab} index={0}>
            <InformationsTab />
          </TabPanel>
          <TabPanel value={currentTab} index={1}>
            <MaterialNeedTab />
          </TabPanel>
          <TabPanel value={currentTab} index={2}>
            <ShippingTab />
          </TabPanel>
          <TabPanel value={currentTab} index={3}>
            <AdminTab />
          </TabPanel>
        </div>
      </Paper>

      {/* Modals and Poppins */}
      <ProfileEDBModals />
    </Layout>
  );
}

export default EDBProfileContent;
